<template>
  <div>
    <b-modal
      ref="my-modal"
      centered
      :show.sync="isActiveLocal"
      header-classes="bg-primary items-center rounded-none text-lg uppercase font-bold"
      modal-content-classes="cust-medi-popup cust-overflow-y-grey cust-close-pop"
      hide-footer
      class="overflow-y-hidden"
    >
      <template slot="modal-title">
        <h3
          class="lg:text-xl md:text-xl text-lg font-semibold text-white bg-primary"
        >
          Bank Transfer Details :
        </h3></template
      >
      <div class="d-block text-left">
        <p class="fsize16 sm-fsize14">
          Friends of Caregiver Saathi is a U.S.-based organization dedicated to
          supporting the vital work of the Caregiver Saathi Foundation in India.
          We are committed to empowering family caregivers across South Asia,
          with a special focus on women.<br /><br />
          Tax payer ID: 87-3617959<br />
          Account number: 8565018457<br />
          The name on your account as it appears<br />
          on your statement. Friends of Caregiver Saathi<br />
          Bank name: Wells Fargo Bank <br />
          Bank address: 420 Montgomery Street San Francisco CA 94104<br />
          For domestic (U.S.) wire: Wire routing transit number/ABA: 121000248
          <br />
          For international wire sent in U.S. dollars or if the currency the
          wire is being sent in is unknown: SWIFT Code: WFBIUS6S<br />
          For international wire sent in a foreign currency from the initiating
          bank: SWIFT Code: WFBIUS6WFFX <br />
          <br />
          You can send the cheque to: Friends of Caregiver Saathi 867 Dwight
          Ave, Sunnyvale, CA-94086
        </p>
      </div>
    </b-modal>
    <div class="flex justify-center mx-auto lg:pt-0 md:pt-0 pt-2 container">
      <div>
        <h1
          class="text-black lg:text-4xl md:text-2xl text-xl text-center font-bold"
        >
          You can help by Donating
        </h1>
        <p class="text-center mt-3 fsize14 smfsize10 lg:mb-0 md:mb-0 mb-4">
          Your Donation to the Caregiver Saathi Foundation supports our
          advocacy, <br />awareness and training programmes for family
          caregivers.<br />
          Support us monthly through our monthly giving program, where you can
          automatically <br />
          donate a specific amount to us every month. Every Month a small amount
          of donation <br />
          from you will be a significant amount for us.
        </p>
      </div>
    </div>
    <div class="flex justify-center items-center mx-auto lg:px-24 container">
      <div class="grid lg:grid-cols-2 grid-cols-1 lg:mt-9 gap-12">
        <div class="shadow-xl border-2 lg:p-10 p-5 heity">
          <h2 class="text-center text-black pt-10 text-2xl">
            For Indian Donors:
          </h2>
          <p class="text-center py-12">
            We are a Section 8 company with 12A / 80G certification which means
            that your donation is tax exempt as per IT ACT of 1961.
          </p>
          <div class="flex justify-center pb-5">
            <a
              target="_blank"
              href="https://pages.razorpay.com/caregiversaathi-donation"
            >
              <b-button variant="primary">Donate</b-button>
            </a>
          </div>
        </div>
        <div class="shadow-xl border-2 lg:p-10 p-5 heity">
          <h2 class="text-center text-black pt-10 text-2xl">
            For International Donors<br />
            (USA-Based):
          </h2>
          <p class="text-center py-6">
            You can send us your contribution via our support organisation in
            the USA – Friends of Caregiver Saathi. As a registered 501(c)(3)
            organization, donations are tax-deductible to the extent allowed by
            law.
          </p>
          <div class="flex justify-center">
            <!-- @click="showModal" -->
            <b-button
              variant="primary"
              id="show-btn"
              @click="handleRedirect()"
              class="lg:my-0 md:my-0 my-4"
              >Know More</b-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleRedirect() {
      this.$router.push({
        name: "friends-caregiversaathi",
      });
    },
    showModal() {
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
  },
};
</script>
<style>
.modal-header {
  background-color: #4f0a4b;
}
</style>
